export function getFirebaseUserMessage(error) {
    const code = typeof error === 'string' ? error : error?.code || '';
    const message = (typeof error === 'string' ? error : error?.message || '').toLowerCase();

    if (code === 'permission-denied' || message.includes('permission-denied') || message.includes('permission denied')) {
        return 'You do not have permission to perform this action. Please check your access rights.';
    }
    if (code === 'unavailable' || message.includes('unavailable')) {
        return 'The service is temporarily unavailable. Please try again in a moment.';
    }
    if (code === 'network-request-failed' || message.includes('network') || message.includes('fetch')) {
        return 'Network error. Please check your internet connection and try again.';
    }
    if (code === 'unauthenticated' || message.includes('unauthenticated') || message.includes('auth')) {
        return 'You must be logged in to perform this action.';
    }
    if (code === 'not-found' || message.includes('not found')) {
        return 'The requested record could not be found.';
    }
    if (code === 'already-exists' || message.includes('already exists')) {
        return 'This record already exists.';
    }
    if (code === 'resource-exhausted' || message.includes('quota')) {
        return 'The system is busy. Please try again later.';
    }
    if (code === 'failed-precondition' || message.includes('precondition')) {
        return 'The operation could not be completed due to a system constraint.';
    }
    if (code === 'aborted' || message.includes('aborted')) {
        return 'The operation was aborted. Please try again.';
    }
    if (code === 'out-of-range' || message.includes('out of range')) {
        return 'The provided value is out of the allowed range.';
    }
    if (code === 'unimplemented' || message.includes('unimplemented')) {
        return 'This feature is not yet available.';
    }
    if (code === 'internal' || message.includes('internal error')) {
        return 'An internal server error occurred. Please try again later.';
    }
    if (code === 'deadline-exceeded' || message.includes('deadline') || message.includes('timeout')) {
        return 'The request timed out. Please try again.';
    }

    return null;
}

export function getErrorMessage(error, fallback = 'An unexpected error occurred. Please try again.') {
    if (!error) return fallback;

    const firebaseMsg = getFirebaseUserMessage(error);
    if (firebaseMsg) return firebaseMsg;

    const rawMessage = typeof error === 'string' ? error : error?.message || '';
    if (!rawMessage.trim()) return fallback;

    // Validation errors are deliberately produced by this application and are
    // safe to show. Unknown provider errors can contain implementation details,
    // so callers receive their operation-specific fallback instead.
    if (/^(Missing required fields:|[A-Z][^.!]* (?:is|required|must be|cannot be)|Invalid )/.test(rawMessage)) {
        return rawMessage;
    }

    return fallback;
}
